/**
 * Just a loading icon
 */
import React, { Component } from 'react';
import i18n from '../../config/i18n';
import loadingIcon from '../../styles/icons/loading.svg';

class LoadingIcon extends Component {
  render() {
    return (
      <div className="LoadingIcon">
        <img
          className="svg-icon animation-spinning"
          alt={i18n.t('loading')}
          src={loadingIcon}
        />
      </div>
    );
  }
}

export default LoadingIcon;



// WEBPACK FOOTER //
// ./src/components/shared/LoadingIcon.js